/* ============================================================
   Mix & Match Bundle – Logik
   Datei-Speicherort: assets/mix-and-match-bundle.js
   ============================================================ */

(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.mmInitialized === 'true') return;
    root.dataset.mmInitialized = 'true';

    var sectionId = root.dataset.sectionId;
    var cfg = (window.MMBundleConfig && window.MMBundleConfig[sectionId]) || {};
    var moneyFormat = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
    var routes = cfg.routes || { cartAdd: '/cart/add.js', cart: '/cart' };

    /* ---- Money Formatter (Shopify-kompatibel) ---- */
    function formatMoney(cents) {
      if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      var value = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + value;
    }

    /* ---- DOM refs ---- */
    var tier1Min = parseInt(root.dataset.minItemsTier1, 10) || 0;
    var tier1Disc = parseFloat(root.dataset.discountTier1) || 0;
    var tier1Code = (root.dataset.discountCodeTier1 || '').trim();
    var tier2Min = parseInt(root.dataset.minItemsTier2, 10) || 0;
    var tier2Disc = parseFloat(root.dataset.discountTier2) || 0;
    var tier2Code = (root.dataset.discountCodeTier2 || '').trim();
    var successAction = root.dataset.successAction || 'redirect_cart';

    var cards = root.querySelectorAll('[data-mm-product]');
    var itemsList = root.querySelector('[data-mm-items]');
    var itemsEmpty = root.querySelector('[data-mm-items-empty]');
    var countEl = root.querySelector('[data-mm-count]');
    var subtotalEl = root.querySelector('[data-mm-subtotal]');
    var totalEl = root.querySelector('[data-mm-total]');
    var discountRow = root.querySelector('[data-mm-discount-row]');
    var discountLabel = root.querySelector('[data-mm-discount-label]');
    var discountAmount = root.querySelector('[data-mm-discount-amount]');
    var checkoutBtn = root.querySelector('[data-mm-checkout]');
    var cartLabel = root.querySelector('[data-mm-cart-label]');
    var progressBar = root.querySelector('[data-mm-progress-bar]');
    var progressText = root.querySelector('[data-mm-progress-text]');
    var tierEls = root.querySelectorAll('[data-tier]');

    /* ---- State ---- */
    var selection = new Map();

    function totalQty() {
      var sum = 0;
      selection.forEach(function (it) { sum += it.qty; });
      return sum;
    }
    function calcSubtotal() {
      var sum = 0;
      selection.forEach(function (it) { sum += it.price * it.qty; });
      return sum;
    }
    function activeTier(qty) {
      if (tier2Min > 0 && qty >= tier2Min) {
        return { tier: 2, disc: tier2Disc, code: tier2Code, min: tier2Min };
      }
      if (tier1Min > 0 && qty >= tier1Min) {
        return { tier: 1, disc: tier1Disc, code: tier1Code, min: tier1Min };
      }
      return null;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (m) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
      });
    }

    function getCardData(card) {
      var variantSelect = card.querySelector('[data-variant-select]');
      var variantId = card.dataset.variantId;
      var price = parseInt(card.dataset.price, 10) || 0;

      if (variantSelect) {
        variantId = variantSelect.value;
        var opt = variantSelect.options[variantSelect.selectedIndex];
        if (opt && opt.dataset.price) {
          price = parseInt(opt.dataset.price, 10) || price;
        }
      }

      var titleEl = card.querySelector('.mm-bundle__card-title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var img = card.querySelector('.mm-bundle__card-imagewrap img');
      var image = img ? img.src : '';
      var productId = card.dataset.productId;

      return { variantId: variantId, price: price, title: title, image: image, productId: productId };
    }

    /* ---- Bild der Card auf Variantenbild umschalten ---- */
    function updateCardImage(card, opt) {
      var cardImg = card.querySelector('.mm-bundle__card-imagewrap img');
      if (!cardImg || !opt) return;

      var newImage = opt.dataset.image;
      var newSrcset = opt.dataset.imageSrcset;

      if (newImage) {
        // Variante hat ein eigenes Bild
        cardImg.setAttribute('src', newImage);
        cardImg.setAttribute('srcset', newSrcset || (newImage + ' 1x'));
      } else {
        // Variante hat kein eigenes Bild → zurück zum Produkt-Default
        var defaultImage = cardImg.dataset.defaultImage;
        var defaultSrcset = cardImg.dataset.defaultSrcset;
        if (defaultImage) {
          cardImg.setAttribute('src', defaultImage);
          cardImg.setAttribute('srcset', defaultSrcset || (defaultImage + ' 1x'));
        }
      }
    }

    function syncCard(card) {
      var d = getCardData(card);
      var qtyWrap = card.querySelector('[data-mm-qty]');
      var addBtn = card.querySelector('[data-mm-add]');
      var qtyVal = card.querySelector('[data-mm-qty-value]');
      var item = selection.get(d.variantId);
      var q = item ? item.qty : 0;

      if (q > 0) {
        addBtn.hidden = true;
        qtyWrap.hidden = false;
        qtyVal.textContent = q;
        card.classList.add('is-selected');
      } else {
        addBtn.hidden = false;
        qtyWrap.hidden = true;
        card.classList.remove('is-selected');
      }
    }

    function render() {
      var qty = totalQty();
      var subtotal = calcSubtotal();
      var tier = activeTier(qty);

      countEl.textContent = qty;

      /* Items list */
      itemsList.innerHTML = '';
      if (qty === 0) {
        itemsList.appendChild(itemsEmpty);
      } else {
        selection.forEach(function (it, vid) {
          var li = document.createElement('li');
          li.className = 'mm-bundle__item';
          var imgHtml = it.image
            ? '<img src="' + escapeHtml(it.image) + '" alt="">'
            : '<div class="mm-bundle__card-placeholder" style="width:44px;height:44px;border-radius:6px"></div>';
          li.innerHTML =
            imgHtml +
            '<div class="mm-bundle__item-info">' +
              '<div class="mm-bundle__item-title">' + escapeHtml(it.title) + '</div>' +
              '<div class="mm-bundle__item-meta">' + it.qty + ' × ' + formatMoney(it.price) + '</div>' +
            '</div>' +
            '<button type="button" class="mm-bundle__item-remove" aria-label="Entfernen" data-remove="' + escapeHtml(vid) + '">×</button>';
          itemsList.appendChild(li);
        });
      }

      /* Totals */
      subtotalEl.textContent = formatMoney(subtotal);
      if (tier && tier.disc > 0) {
        var discValue = 0;
selection.forEach(function(it) {
  discValue += Math.floor(it.price * (tier.disc / 100)) * it.qty;
});
        discountRow.hidden = false;
        discountLabel.textContent = 'Rabatt (' + tier.disc + '%)';
        discountAmount.textContent = '−' + formatMoney(discValue);
        totalEl.textContent = formatMoney(subtotal - discValue);
      } else {
        discountRow.hidden = true;
        totalEl.textContent = formatMoney(subtotal);
      }

      /* Progress */
      if (progressBar && (tier1Min > 0 || tier2Min > 0)) {
        var target = tier2Min > 0 ? tier2Min : tier1Min;
        var pct = Math.min(100, (qty / target) * 100);
        progressBar.style.setProperty('--mm-progress', pct + '%');

        if (tier && tier.tier === 2) {
          progressText.innerHTML = '🎉 <strong>' + tier2Disc + '% Rabatt freigeschaltet!</strong>';
        } else if (tier && tier.tier === 1) {
          if (tier2Min > 0) {
            var need2 = tier2Min - qty;
            progressText.innerHTML =
              '<strong>' + tier1Disc + '% Rabatt aktiv!</strong> Noch ' +
              need2 + ' Produkt' + (need2 === 1 ? '' : 'e') + ' für ' + tier2Disc + '%.';
          } else {
            progressText.innerHTML = '🎉 <strong>' + tier1Disc + '% Rabatt freigeschaltet!</strong>';
          }
        } else if (tier1Min > 0) {
          var need1 = tier1Min - qty;
          progressText.innerHTML =
            'Noch <strong>' + need1 + ' Produkt' + (need1 === 1 ? '' : 'e') +
            '</strong> für ' + tier1Disc + '% Rabatt.';
        }
      }

      /* Tier highlight */
      tierEls.forEach(function (el) {
        var t = parseInt(el.dataset.tier, 10);
        var on = !!(tier && tier.tier >= t);
        el.classList.toggle('is-active', on);
      });

      /* Checkout button */
      checkoutBtn.disabled = qty === 0;
      cartLabel.textContent = qty === 0
        ? 'Bundle in den Warenkorb'
        : qty + ' Produkt' + (qty === 1 ? '' : 'e') + ' in den Warenkorb';
    }

    /* ---- Card events ---- */
    cards.forEach(function (card) {
      var addBtn = card.querySelector('[data-mm-add]');
      var incBtn = card.querySelector('[data-mm-increase]');
      var decBtn = card.querySelector('[data-mm-decrease]');
      var variantSelect = card.querySelector('[data-variant-select]');

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var d = getCardData(card);
          if (!d.variantId) return;
          var existing = selection.get(d.variantId);
          if (existing) {
            existing.qty += 1;
          } else {
            selection.set(d.variantId, {
              qty: 1, price: d.price, title: d.title,
              image: d.image, productId: d.productId
            });
          }
          syncCard(card);
          render();
        });
      }
      if (incBtn) {
        incBtn.addEventListener('click', function () {
          var d = getCardData(card);
          var item = selection.get(d.variantId);
          if (item) item.qty += 1;
          syncCard(card);
          render();
        });
      }
      if (decBtn) {
        decBtn.addEventListener('click', function () {
          var d = getCardData(card);
          var item = selection.get(d.variantId);
          if (!item) return;
          item.qty -= 1;
          if (item.qty <= 0) selection.delete(d.variantId);
          syncCard(card);
          render();
        });
      }
      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          var oldId = card.dataset.variantId;
          if (selection.has(oldId)) selection.delete(oldId);
          card.dataset.variantId = variantSelect.value;
          var opt = variantSelect.options[variantSelect.selectedIndex];
          if (opt && opt.dataset.price) {
            card.dataset.price = opt.dataset.price;
          }

          /* Bild auf Variantenbild umschalten (oder zurück zum Default) */
          updateCardImage(card, opt);

          syncCard(card);
          render();
        });
      }
    });

    /* ---- Remove from summary ---- */
    itemsList.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-remove]');
      if (!btn) return;
      var vid = btn.dataset.remove;
      selection.delete(vid);
      cards.forEach(function (c) { syncCard(c); });
      render();
    });

    /* ---- Add to cart ---- */
    checkoutBtn.addEventListener('click', function () {
      if (selection.size === 0) return;
      checkoutBtn.classList.add('is-loading');
      var originalLabel = cartLabel.textContent;
      cartLabel.textContent = 'Wird hinzugefügt …';

      var items = [];
      selection.forEach(function (it, vid) {
        items.push({ id: parseInt(vid, 10), quantity: it.qty });
      });

      fetch(routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(function () {
          var tier = activeTier(totalQty());

          // Mit Rabattcode → Discount-URL (Shopify wendet Code automatisch an)
          if (tier && tier.code) {
            var redirectTarget = successAction === 'redirect_checkout' ? '/checkout' : routes.cart;
            window.location.href = '/discount/' + encodeURIComponent(tier.code) +
              '?redirect=' + encodeURIComponent(redirectTarget);
            return;
          }

          // Ohne Rabattcode
          if (successAction === 'redirect_checkout') {
            window.location.href = '/checkout';
          } else if (successAction === 'stay') {
            // Falls dein Theme einen Cart-Drawer hat, sollte er per Event aufgehen.
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));
            // Fallback: button kurz zurücksetzen
            checkoutBtn.classList.remove('is-loading');
            cartLabel.textContent = '✓ Hinzugefügt – noch mehr?';
            setTimeout(function () { cartLabel.textContent = originalLabel; }, 2500);
          } else {
            window.location.href = routes.cart;
          }
        })
        .catch(function (err) {
          console.error('[mm-bundle] error', err);
          cartLabel.textContent = 'Fehler – bitte erneut versuchen';
          setTimeout(function () { cartLabel.textContent = originalLabel; }, 2500);
        })
        .finally(function () {
          checkoutBtn.classList.remove('is-loading');
        });
    });

    render();
  }

  /* ---- Boot ---- */
  function boot() {
    document.querySelectorAll('[data-mm-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme-Editor: Re-init bei dynamisch geladenen Sections
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-mm-bundle]');
    if (section) init(section);
  });
})();